import $ from "jquery"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import * as ses from "../../../configurations/session/sessioncomplete"
import AuthService from "../../../configurations/authentications/auth";
import baseurl from "../../../configurations/baseurl/baseurl"


const Auth = new AuthService();

export const actions = {

    LoadProfile({ commit }) {
        baseurl
            .get(rt.Userprofile)
            .then(res => {
               
                $('.profileLoad').hide()
                if (res.data.code === 200) {
                    commit('STORE_USER_PROFILE', res.data.profile);
                    commit('STORE_USER_ROLE', res.data)
                } else if (res.data.code === 404) {
                    ers.errorLoadingUserProfile()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },
    updateProfile({ commit }) {
        let userDetails = {
            id: $('.id').val(),
            fullnames: $('.fullnames').val(),
            profilename: $('.profilename').val(),
            gender: $('.gender').val(),
            email: $('.email').val(),
            accountstatus: $('.accontstatus').val(),
            password: $('.password').val()
        }
        $('.updatingUser').hide()
        $('.updatingUserLoader').show()
        baseurl
            .post(rt.updateProfile, userDetails)
            .then(res => {
                
                $('.updatingUserLoader').hide()
                $('.updatingUser').show()
                if (res.data.code === 200) {
                    suc.userUpdateSuccess()
                    commit('STORE_USER_PROFILE', res.data.profile);
                    commit('STORE_USER_ROLE', res.data)
                } else if (res.data.code === 402) {
                    ers.validateErrors()
                } else if (res.data.code === 404) {
                    ers.errorUpdatingUser()
                } else if (res.data.code === 405) {
                    ers.noPermissionToUpdate()
                } else if (res.data.code === 506) {
                    ses.sessionComplete()
                }

            })
    },

    updateUserImage({ commit }) {

        let image = {
            profileImg: $('.profileImg').val()
        }
        console.log(image);
        window.$('#userImageModal').modal('show')
        baseurl
            .post(rt.updateProfileImg, image)
            .then(res => {
               
                window.$('#userImageModal').modal('hide')                
                localStorage.removeItem('img')
                if (res.data.code === 200) {
                    suc.uploadProfilePicSuccess()
                    commit('STORE_USER_PROFILE', res.data.profile);
                    commit('STORE_USER_ROLE', res.data)
                    Auth.setUsername(res.data.profile.profilename)
                    Auth.setprofile(res.data.profile.profile_img)                   
                    commit('STORE_CURRENT_USERNAME',res.data.profile.profilename)
                    commit('STORE_CURRENT_PIC',res.data.profile.profile_img)
                    $('.uploadIcons').show()
                    $('.updateImgBtn').hide()
                }else if (res.data.code === 404) {
                    ers.errorUpdatingProfileImg()
                }else if (res.data.code === 506) {
                    ses.sessionComplete()
                }
            })
    },

    signOut(){
        Auth.logout()
    }


}
export default actions


// WEBPACK FOOTER //
// ./src/vuex/modules/userprofile/actions.js